import {
  analyticsApiRef,
  AnyApiFactory,
  ConfigApi,
  configApiRef,
  createApiFactory,
  IdentityApi,
  identityApiRef,
} from '@backstage/core-plugin-api';
import {
  ScmAuth,
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
} from '@backstage/integration-react';
import {
  PDPAnalytics,
  pdpAnalyticsApiRef,
} from '@principal-developer-portal/plugin-analytics-frontend';
import { GoogleAnalytics4 } from '@backstage-community/plugin-analytics-module-ga4';
import { MultipleAnalyticsApi } from '@backstage/core-app-api';

/**
 * In case ga4 isn't configured for this environment (ex. local)
 * we don't want to fail the entire MultipleAnalyticsApi,
 * so we provide this with a try/catch.
 */
const ga4Config = ({
  configApi,
  identityApi,
}: {
  configApi: ConfigApi;
  identityApi: IdentityApi;
}) => {
  try {
    return [
      GoogleAnalytics4.fromConfig(configApi, {
        identityApi,
      }),
    ];
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  return [];
};
export const vendorApi: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  // Instantiate and register the GA and PDP analytics API implementations.
  createApiFactory({
    api: analyticsApiRef,
    deps: {
      configApi: configApiRef,
      identityApi: identityApiRef,
      pdpAnalyticsApi: pdpAnalyticsApiRef,
    },
    factory: ({ configApi, identityApi, pdpAnalyticsApi }) =>
      MultipleAnalyticsApi.fromApis([
        new PDPAnalytics({ pdpAnalyticsApi, identityApi }),
        ...ga4Config({ configApi, identityApi }),
      ]),
  }),
];
